module.exports = __webpack_public_path__ + "img/tron (36).68ef4395.jpg";